import { render, staticRenderFns } from "./SliceIcon.vue?vue&type=template&id=706cab21&"
import script from "./SliceIcon.vue?vue&type=script&lang=js&"
export * from "./SliceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports